// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deposits-container-nUKDs {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-left: 10px;
}

.deposits-table_container-dW5nW {
  padding: 0px 10px;
}

.deposits-tableHeader_cellContent-b8_Th {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
}

.deposits-addButton_base-b45qA {
  width: max-content;
  margin-left: auto;
}

.deposits-description-bacEN {
  width: 100%;
  min-width: 280px;
  white-space: normal;
  padding: 8px 26px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/provider/deposits/deposits.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding-left: 10px;\n}\n\n.table_container {\n  padding: 0px 10px;\n}\n\n.tableHeader_cellContent {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.addButton_base {\n  width: max-content;\n  margin-left: auto;\n}\n\n.description {\n  width: 100%;\n  min-width: 280px;\n  white-space: normal;\n  padding: 8px 26px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `deposits-container-nUKDs`,
	"table_container": `deposits-table_container-dW5nW`,
	"tableHeader_cellContent": `deposits-tableHeader_cellContent-b8_Th`,
	"addButton_base": `deposits-addButton_base-b45qA`,
	"description": `deposits-description-bacEN`
};
export default ___CSS_LOADER_EXPORT___;
